import { staticText } from '../../../utils/translations/staticText';

const money101Translation = staticText({
  brand_reward: {
    _: 'Moneymax Reward',
  },
  brand_reward_stk_bka: {
    _: 'Moneymax Reward',
  },
  brand_reward_product_modal: {
    _: 'Moneymax Reward',
  },
  brand_reward_product_modal_cc: {
    _: 'Moneymax Reward',
  },
});
export default money101Translation;
